<template>
  <div class="porp-box">
    <div class="porp-body">
      <div class="switchAddressBox"> 
        <div class="address" @click="addressAdd">
          <span>收货地址</span>
          <img src="//image01.homedo.com/Files/Images/cms/www/20240509/5152040881627494245_pic1.png">
        </div>

        <div class="siteBox" @click="addressAdd">
          <geoAddress :region="region"/>
        </div>
      </div>
      <dl v-if="activityTagList.length>0">
        <dt>
          <h4 class="flex-left">热门活动</h4>
          <a v-if="activityTagList.length > 6" class="flex-left" href="JavaScript:;" :class={cur:activeShowMore} @click="activeShowMore=!activeShowMore">
            {{activeShowMore ? '收起':'展开全部'}}
          </a>
          <template v-if="activeSelectInfo && activeSelectInfo.activityName">
            <img :src="activeSelectInfo.picUrl" @error="activeSelectInfo.picUrl=''" v-if="activeSelectInfo.picUrl">
            <span v-else>{{activeSelectInfo.activityName}}</span>
          </template>

        </dt>

        <dd class="flex-left transition-all">
          <p v-for="active in activityFilterList" :key="active.id" @click.stop="selectActive(active)">
            <img :src="active.picUrl" @error="active.picUrl=''" v-if="active.picUrl">
            <a v-else href="JavaScript:;" :class="{cur:active.isSelect}">{{active.activityName}}</a>
          </p>
        </dd>
      </dl>
      <dl v-for="(option,index) in filterList" :key="index">
        <dt>
          <h4 class="flex-left">{{option.name}}</h4>
          <a v-if="option.valueList.length > 6" class="flex-left" href="JavaScript:;" :class={cur:option.showMore} @click="setShowMore(index)">
            {{option.showMore ? '收起':'展开全部'}}
          </a>
          <span v-if="option.valueList[0] && option.valueList[0].isSelect">{{option.valueList[0].name}}</span>
        </dt>
        <dd :style="filterStyle(index)" :class="option.name =='品牌'?'lex-left transition-all tran-brand':'flex-left transition-all'">
          <p v-for="(t,i) in option.valueList" :key="i">
            <a href="JavaScript:;" @click.stop="clickListFnPorp(t)" :class="{cur:t.isSelect}" v-if="option.name =='品牌'"><img :src="t.picUrl" @error="onerrorFun($event)"></a>
            <a href="JavaScript:;" @click.stop="clickListFnPorp(t)" :class="{cur:t.isSelect}" v-else>{{t.name}}</a>
          </p>
        </dd>
      </dl>
    </div>
    <div class="btn-box-btn">
      <div class="btn-porp flex-center">
        <a href="JavaScript:;" class="flex-center" @click.stop="resetSearch()">重置</a>
        <a href="JavaScript:;" class="flex-center blue" @click.stop="openClosePorp(false)">确定({{productTotal}})</a>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
Vue.use(geoRegion)

let vm = null
import { getSearchFiltrate } from '../../../request/search.js'
export default {
  props: ['filterObj'],
  data() {
    return {
      region: [], // 地址文本
      listMap: [],
      filterList: [],
      activityTagList: [],
      productTotal: 0,
      filterDetail: '',
      activeShowMore: false,
      activeSelectInfo: {},
    }
  },
  created() {
    vm = this
    vm.getSearchFiltrate()
    function convertToObjectArray(obj) {
        var result = []
        var provinceObject = {
          name: 'provinceId',
          id: obj.provinceId,
          text: obj.provinceName
        }
        result.push(provinceObject)
        var cityObject = {
          name: 'cityId',
          id: obj.cityId,
          text: obj.cityName
        }
        result.push(cityObject)
        return result
    }
    var newArray = convertToObjectArray($HMD$.globalCity)
    vm.region = newArray
  },
  computed: {
    activityFilterList() {
      return this.activeShowMore ? this.activityTagList : this.activityTagList.slice(0, 6)
    },
  },
  watch: {},
  methods: {
    childMethod(i) {
      if (Array.isArray(i)) {
        vm.region = i
      } else {
        vm.region = [
          { name: 'provinceId', id: i.provinceId , text: i.provinceName },
          { name: 'cityId', id: i.cityId, text: i.cityName }
        ]
      }
      vm.resetSearch()
    },
    addressAdd() {
      vm.$emit('addressAdd');
    },

    getSearchFiltrate() {
      let param = {
        keyword: vm.filterObj.keyword,
        brandId: vm.filterObj.brandId,
        categoryId: vm.filterObj.categoryId,
        categoryLevel: vm.filterObj.categoryLevel,
        promotionId: vm.filterObj.promotionId,
        productSource:this.filterObj.productSource,
        page: 1,
        pageSize: 10,
        sortBy: 'vcdesc',
        listMap: vm.listMap,
        isCustom: '',
        selectType: 2,
        searchType: '1',
      }
      if (vm.activeSelectInfo.tagIdList) {
        param['searchActivityTagReq'] = { screen: vm.activeSelectInfo.screen, tagIdList: vm.activeSelectInfo.tagIdList }
      }
      getSearchFiltrate(param).then((res) => {
        const { data, respCode } = res.data
        if (data && respCode == '0000') {
          let pageData = data || {}
          if (!pageData.total) {
            // Toast("未匹配到商品，更换筛选试试吧～");
            $HMD$.Prop('未匹配到商品，更换筛选试试吧～')
            vm.listMap.pop()
            return false
          }
          if (pageData.total > 999) {
            vm.productTotal = '999+件商品'
          } else {
            vm.productTotal = (pageData.total ? pageData.total : 0) + '件商品'
          }
          vm.filterList =  []
           pageData.displayList.forEach(item=>{
             if(!(this.filterObj.productSource && item.type==7)){
                vm.filterList.push(item)
             }
           })
          vm.activityTagList =
            pageData.activityTagList.map((active) => {
              return {
                ...active,
                isSelect: active.id == vm.activeSelectInfo.id,
              }
            }) || []
          vm.filterDetail = ''
          if (pageData.displayList && pageData.displayList.length) {
            pageData.displayList.forEach((item, index) => {
              vm.$set(vm.filterList[index], 'showMore', false)
              if (item.valueList && item.valueList.length) {
                item.valueList.forEach((item2) => {
                  if (item2.isSelect) {
                    vm.filterDetail += '【' + item.name + ',' + item2.name + '】,'
                  }
                })
              }
            })
          }
        }
      })
    },
    selectActive(active) {
      if (active.id != this.activeSelectInfo.id) {
        this.activeSelectInfo = Object.assign({}, active)
      } else {
        this.activeSelectInfo = Object.assign({})
      }
      vm.getSearchFiltrate()
    },
    clickListFnPorp(obj) {
      if (obj) {
        let filter = JSON.parse(JSON.stringify(obj))
        filter.isSelect = true
        let fliterIndex = vm.listMap.findIndex((item) => {
          return item.sid === filter.sid && item.type === filter.type
        })
        if (fliterIndex != -1) {
          vm.listMap.splice(fliterIndex, 1)
        } else {
          if (filter.type == 5) {
            let index5 = vm.listMap.findIndex((item) => {
              return item.type == 5
            })
            if (index5 > -1) {
              vm.listMap.splice(index5, 1, filter)
            } else {
              vm.listMap.push(filter)
            }
          } else if (filter.type == 7) {
            let index7 = vm.listMap.findIndex((item) => {
              return item.type == 7
            })
            if (index7 > -1) {
              vm.listMap.splice(index7, 1, filter)
            } else {
              vm.listMap.push(filter)
            }
          } else {
            vm.listMap.push(filter)
          }
        }
      } else {
        vm.listMap = []
      }
      vm.getSearchFiltrate()
    },
    resetSearch() {
      vm.listMap = []
      this.activeSelectInfo = {}
      vm.getSearchFiltrate()
      let emitMap = { listMap: vm.listMap, filterDetail: vm.filterDetail }
      if (vm.activeSelectInfo.tagIdList) {
        emitMap['searchActivityTagReq'] = { screen: vm.activeSelectInfo.screen, tagIdList: vm.activeSelectInfo.tagIdList }
      }
      vm.$emit('change-event', emitMap, false)
    },
    openClosePorp() {
      let emitMap = { listMap: vm.listMap, filterDetail: vm.filterDetail }
      if (vm.activeSelectInfo.tagIdList) {
        emitMap['searchActivityTagReq'] = { screen: vm.activeSelectInfo.screen, tagIdList: vm.activeSelectInfo.tagIdList }
      }
      vm.$emit('change-event', emitMap, true)
    },
    filterStyle(index) {
      let oStyle = 'height:'
      if (vm.filterList && vm.filterList.length) {
        if (vm.filterList[index].valueList && vm.filterList[index].valueList.length > 6) {
          oStyle = 'height:'
          oStyle += (vm.filterList[index].showMore ? Math.ceil(vm.filterList[index].valueList.length / 3) : 2) * 4.2
          oStyle += 'rem;'
        } else {
          vm.filterList[index].showMore = false
        }
      }
      return oStyle
    },
    setShowMore(index) {
      let showMore = !vm.filterList[index].showMore
      vm.$set(vm.filterList[index], 'showMore', showMore)
    },
    onerrorFun: function (e) {
        e.currentTarget.src = 'https://image10.homedo.com/default/Nopic.jpg';
    },
  },
}
</script>
<style scoped lang="less">
@import url(../style/filter.less);
</style>